// "preview" uses the local Week 7 fixture and a local sign-in stub.
// "live" signs in against Directus and only shows approved, published lessons.
export const DATA_MODE =
  process.env.REACT_APP_DATA_MODE === "preview" ? "preview" : "live";

export const IS_PREVIEW = DATA_MODE === "preview";

// Defaults to the app's own origin so the dev-server proxy (package.json
// "proxy") or a same-origin reverse proxy can forward API calls to Directus.
export const DIRECTUS_URL =
  process.env.REACT_APP_DIRECTUS_URL || window.location.origin;

// The classes a teacher teaches come from Directus data (classroom_teachers),
// never from configuration; see data/classrooms.js.

// The learner gateway, which issues one-time codes for setting up a learner
// tablet. Set at build time; without it tablet setup explains it is not
// available rather than calling this app's own server.
export const GATEWAY_URL = (process.env.REACT_APP_GATEWAY_URL || "").replace(
  /\/$/,
  ""
);
